/** @prettier */

/**
 * 歯車メニュー
 */

import React, {useState} from 'react';
import {
  Menu,
  MenuItem,
  IconButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import {useTranslation} from 'react-i18next';

import {iconBlack} from '../define';

export type GearMenuListArgType = {
  id?: string;
  menuItem: {
    id?: string;
    label: string;
    disabled?: boolean;
    onClick?: React.MouseEventHandler<HTMLLIElement>;
    icon?: {
      className: string;
      src: string;
      alt: string;
    };
    MuiIcon?: () => JSX.Element;
  }[];
};
/**
 * 歯車メニュー
 * @param id メニューごとで一意のID
 * @param menuItem.label リストの名前
 * @param menuItem.onClick リストを押下した時の処理
 * @param menuItem.icon.className アイコンに適用するクラス名
 * @param menuItem.icon.src アイコンデータ
 * @param menuItem.icon.alt アイコンが表示されない時に表示される文字
 * @param menuItem.MuiIcon muiアイコン（menuItem.iconに入力がある場合はmenuItem.iconが優先される）
 * @param menuItem.disable 項目を無効化するか否か
 * @returns JSX
 */
const GearMenu = (props: GearMenuListArgType) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const isOpenMenu = Boolean(anchorEl);

  const trans = useTranslation().t; //翻訳関数

  /**
   * 歯車ボタン押下時の処理
   * @param event
   */
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  /**
   * メニューリストを閉じる処理
   */
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton
        id={`${props.id}-button`}
        aria-controls={isOpenMenu ? 'menu-list-grow' : undefined}
        aria-haspopup="true"
        aria-expanded={isOpenMenu ? 'true' : undefined}
        onClick={handleClick}>
        <img
          className="gearMenuIcon"
          src={iconBlack.SETTINGS.src}
          alt={`${trans(
            `GearMenuList.image.alternativeText.${iconBlack.SETTINGS.alt}`
          )}`}
        />
        <img
          className="gearMenuIcon"
          src={iconBlack.CHEVRON_DOWN.src}
          alt={`${trans(
            `GearMenuList.image.alternativeText.${iconBlack.CHEVRON_DOWN.alt}`
          )}`}
        />
      </IconButton>
      <Menu
        id={`${props.id}-menu`}
        anchorEl={anchorEl}
        open={isOpenMenu}
        onClose={handleClose}>
        {props.menuItem.map((item, index) => (
          <MenuItem
            id={item.id}
            key={index}
            disabled={item.disabled}
            onClick={event => {
              if (item.onClick !== undefined) item.onClick(event);
              handleClose();
            }}>
            {item.icon !== undefined ? (
              <ListItemIcon>
                <img
                  className={item.icon.className}
                  src={item.icon.src}
                  alt={item.icon.alt}
                />
              </ListItemIcon>
            ) : item.MuiIcon !== undefined ? (
              <ListItemIcon>
                <item.MuiIcon />
              </ListItemIcon>
            ) : (
              <></>
            )}
            <ListItemText>{item.label}</ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
export default GearMenu;
